import React from 'react';
import { ButtonElement, ButtonElementProps } from './ButtonElement';

export type ButtonProps = ButtonElementProps &
    React.HTMLAttributes<HTMLButtonElement> & {
        type?: 'button' | 'submit' | 'reset';
    };

export const Button = React.forwardRef<HTMLElement, ButtonProps>(({ type = 'button', ...props }, ref) => {
    return <ButtonElement tag="button" type={type} {...props} ref={ref} />;
});

